import { Spinner, Text } from '@chakra-ui/react';
import useAccountIdQueryParam from 'hooks/modules/brokerAccount/useAccountIdQueryParam';
import usePeriodQueryParam from 'hooks/modules/period/usePeriodQueryParam';
import OpenedPositionsTable from 'presentation/components/modules/portfolio/openedPositions/OpenedPositionsTable';
import AppCard from 'presentation/components/shared/card/AppCard';
import ErrorContainer from 'presentation/components/shared/ErrorContainer';
import GridHeading from 'presentation/components/shared/grid/GridHeading';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useFetchPortfolioQuery } from 'rtkQuery/sharespro/queries/portfolio';

const PortfolioOpenedPositionsContainer: FC = () => {
  const [accountId] = useAccountIdQueryParam();
  const [period] = usePeriodQueryParam();
  const { data, error, refetch, isFetching } = useFetchPortfolioQuery({
    period,
    account_id: accountId,
  });

  const { t } = useTranslation();

  let content;
  if (data) {
    if (data.positions.length > 0) {
      content = <OpenedPositionsTable items={data.positions} />;
    } else {
      content = <Text textAlign="center">{t('listIsEmpty')}</Text>;
    }
  } else if (isFetching) {
    content = <Spinner />;
  } else if (error) {
    content = (
      <ErrorContainer
        error={error}
        onRetry={() => {
          refetch();
        }}
      />
    );
  } else {
    content = <Spinner />;
  }

  return (
    <>
      <GridHeading>{t('portfolioOpenedPositionsTitle')}</GridHeading>
      <AppCard
        p="20px"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        {content}
      </AppCard>
    </>
  );
};

export default PortfolioOpenedPositionsContainer;
